export default "__VITE_ASSET__LwILDxjP__"